import React from 'react';
import PrivacyPolicy from '../../components/PrivacyPolicy/PrivacyPolicy';

function VeilPrivacy() {
  const sections = [
    {
      title: 'Introduction',
      content: (
        <>
          <p>
            Veil is a privacy filter hardware device featuring NFC technology. This Privacy Policy explains
            how Castle Point Innovations LLC ("we," "us," or "our") collects, uses, stores, and protects
            your information when you visit the Veil marketing website and interact with our services. The
            Veil hardware device itself does not collect, transmit, or store any personal data.
          </p>
          <p>
            By using our website, you agree to the collection and use of information as described in this
            policy. If you do not agree with any part of this policy, please discontinue use of the
            website.
          </p>
        </>
      ),
    },
    {
      title: 'Information We Collect',
      content: (
        <>
          <p>
            Our data collection is limited to information gathered through the Veil marketing website. The
            Veil hardware device does not collect any user data. On our website, we may collect:
          </p>
          <ul>
            <li>
              <strong>Contact Form Submissions:</strong> If you contact us through our website, we collect
              the information you provide, such as your name, email address, and message content.
            </li>
            <li>
              <strong>Newsletter Signups:</strong> If you subscribe to our mailing list, we collect your
              email address to send you product updates and announcements.
            </li>
            <li>
              <strong>Web Analytics:</strong> We collect standard analytics data such as page views,
              referrer information, browser type, and general geographic location to understand how
              visitors use our website.
            </li>
          </ul>
        </>
      ),
    },
    {
      title: 'How We Use Your Information',
      content: (
        <>
          <p>We use the information we collect for the following purposes:</p>
          <ul>
            <li>To respond to inquiries and messages submitted through our contact form.</li>
            <li>To send product updates and announcements to newsletter subscribers.</li>
            <li>To analyze website traffic and usage patterns to improve our website content and user experience.</li>
            <li>To communicate with you regarding your inquiries or our products and services.</li>
          </ul>
        </>
      ),
    },
    {
      title: 'Third-Party Services',
      content: (
        <>
          <p>
            Our website is hosted on Vercel. When you visit our website, your request is processed through
            Vercel's infrastructure. Vercel may collect standard server logs including IP addresses and
            request metadata in accordance with its own privacy policy.
          </p>
          <p>
            We encourage you to review Vercel's privacy policy for details on how they handle data. We do
            not sell or share your personal information with any other third parties for marketing purposes.
          </p>
        </>
      ),
    },
    {
      title: 'Data Storage and Security',
      content: (
        <>
          <p>
            Any personal information collected through our website, such as contact form submissions and
            email signups, is stored using secure cloud infrastructure with encryption at rest and in
            transit. We implement reasonable technical and organizational measures to protect your data from
            unauthorized access, alteration, disclosure, or destruction.
          </p>
          <p>
            However, no method of electronic storage or transmission is completely secure, and we cannot
            guarantee absolute security.
          </p>
        </>
      ),
    },
    {
      title: 'Your Rights',
      content: (
        <>
          <p>Depending on your jurisdiction, you may have the following rights regarding your data:</p>
          <ul>
            <li>
              <strong>Access:</strong> You may request a copy of the personal data we hold about you.
            </li>
            <li>
              <strong>Deletion:</strong> You may request that we delete any personal data we have
              collected, such as contact form submissions or newsletter subscriptions.
            </li>
            <li>
              <strong>Correction:</strong> You may request correction of any inaccurate personal data we
              hold about you.
            </li>
            <li>
              <strong>Unsubscribe:</strong> You may unsubscribe from our mailing list at any time using
              the unsubscribe link provided in our emails or by contacting us directly.
            </li>
          </ul>
          <p>
            To exercise any of these rights, please contact us using the information provided in the
            Contact Us section below.
          </p>
        </>
      ),
    },
    {
      title: "Children's Privacy",
      content: (
        <>
          <p>
            Our website is not intended for use by individuals under the age of 13. We do not knowingly
            collect personal information from children under 13. If we become aware that we have
            inadvertently collected data from a child under 13, we will take steps to delete that
            information promptly. If you believe a child under 13 has provided us with personal data,
            please contact us immediately.
          </p>
        </>
      ),
    },
    {
      title: 'Changes to This Policy',
      content: (
        <>
          <p>
            We may update this Privacy Policy from time to time to reflect changes in our practices,
            technologies, or legal requirements. When we make material changes, we will update the "Last
            Updated" date at the top of this policy. We encourage you to review this policy periodically.
          </p>
        </>
      ),
    },
    {
      title: 'Contact Us',
      content: (
        <>
          <p>
            If you have any questions, concerns, or requests regarding this Privacy Policy or our data
            practices, please contact us at:
          </p>
          <p>
            <strong>Email:</strong> contact@castlepointinnovations.com
          </p>
        </>
      ),
    },
  ];

  return <PrivacyPolicy productName="Veil" lastUpdated="March 27, 2026" sections={sections} />;
}

export default VeilPrivacy;
